import React from "react";
import TrendingOrganizationsAndProjects from "../components/ContributorHomePage/TrendingOrganizationsAndProjects";

function TrendingOrganizationsAndProjectsPage() {
  return <TrendingOrganizationsAndProjects />;
}

export default TrendingOrganizationsAndProjectsPage;